<template>
    <div class="modal fade top-most not-full-screen" id="confirm-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Confirm</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body"></div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-test="confirm-modal-ok-button">Ok</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" data-test="confirm-modal-cancel-button">Cancel</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmModal',
}
</script>
